export const  API_ENDPOINTS={
    RM_ALLOCATION :{
            ADD_ALLOCATION:()=>`rm-resource-allocation/create`,
            UPDATE_ALLOCATION:(id)=>`/rm-resource-allocation/${id}` ,
            GET_ALLOCATED_PROJECT:()=>`/rm-resource-allocation/getMyAllocations`,
            GET_ALLOCATION:()=>`/rm-resource-allocation/reportees`,
            OVERALL_SUBMIT:(action)=>`/rm-resource-allocation/submitAll?action=${action}`,
            // UPDATE_ALLOCATION:(id)=>`/rm-resource-allocation/${id}`,
    },  
    HR_RESOURCE_LIST: ({
    page,
    size,
    employeeId,
    monthYear,
    divisionHeadId,
    reviewerId,
    reportingManagerId,
    rmStatus,
    leaveStatus,
    search
  }) => {
    const queryParams = new URLSearchParams();
    if (page != null) queryParams.append("page", page);
    if (size != null) queryParams.append("size", size);
    if (employeeId) queryParams.append("employeeId", employeeId);
    if (monthYear) queryParams.append("monthYear", monthYear);
    if (divisionHeadId) queryParams.append("divisionHeadId", divisionHeadId);
    if (reviewerId) queryParams.append("reviewerId", reviewerId);
    if (reportingManagerId)
      queryParams.append("reportingManagerId", reportingManagerId);
    if (rmStatus) queryParams.append("rmStatus", rmStatus);
    if (leaveStatus) queryParams.append("leaveStatus", leaveStatus);
    if (search) queryParams.append("search", search);
    const queryString = queryParams.toString();
    return queryString
      ? `/rm-resource-allocation/all?${queryString}`
      : `/rm-resource-allocation/all`;
  },
  UPDATE_RM_STATUS: (id, rmStatus) => `/rm-resource-allocation/updateRmStatus/${id}?rmStatus=${rmStatus}`,
  DIVISION_LIST: () => `/users/hr-info/division-head`,
  REVIEWER_BY_DH: (divisionHeadId) => `/users/hr-info/reviewer-by-division-head?divisionHeadId=${divisionHeadId}`,
  RM_BY_REVIEWER: (reviewerId) => `/users/hr-info/reporting-manager-by-reviewer?reviewerId=${reviewerId}`,
  EMPLOYEES_BY_RM: (reportingManagerId) => `/users/hr-info/employees-by-reporting-manager?reportingManagerId=${reportingManagerId}`,
  // EXPORT:()=>`/rm-resource-allocation/export`,
  EXPORT: ({employeeId,monthYear,divisionHeadId,reviewerId,reportingManagerId,rmStatus,leaveStatus} = {}) => {
    const queryParams = new URLSearchParams();
    // if (employeeId) queryParams.append("employeeId", employeeId);
    if (monthYear) queryParams.append("monthYear", monthYear);
    if (divisionHeadId) queryParams.append("divisionHeadId", divisionHeadId);
    if (reviewerId) queryParams.append("reviewerId", reviewerId);
    if (reportingManagerId) {queryParams.append("reportingManagerId", reportingManagerId);
    }
    if (rmStatus) queryParams.append("rmStatus", rmStatus);
    if (leaveStatus) queryParams.append("leaveStatus", leaveStatus);
    const queryString = queryParams.toString();
    return queryString
      ? `/rm-resource-allocation/export?${queryString}`
      : `/rm-resource-allocation/export`;
  },
  };
